export default function reducer(
  state = {
    login: '',
  },
  action
) {
  switch (action.type) {
    case 'LOGIN_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'LOGIN_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        login: action.payload,
      };
    }
    case 'LOGIN_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        login: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
